export const ValidKeyParamsKeys = [
    'identifier',
    'pw_cost',
    'pw_nonce',
    'pw_salt',
    'version',
    'origination',
    'created',
];
